import { api } from './api';

export const getTemplatesBatchService = ({ codes, ...params }, cancelToken) => api.get(
  `/templates/v2/codes/${codes}`,
  {
    cancelToken,
    params,
  },
);

export const getTopicsService = ({ slugs, ...params }, cancelToken) => api.get(
  `/topics/slugs/${slugs}`,
  {
    cancelToken,
    params,
  },
);

export const getTemplatesService = ({ ...params }, cancelToken) => api.get(
  '/templates/v2',
  {
    cancelToken,
    params,
  },
);

export const getTemplateCategoriesService = ({ ...params }, cancelToken) => api.get(
  '/template-categories',
  {
    cancelToken,
    params,
  },
);

export const getTemplateDetailService = ({ code, ...params }, cancelToken) => api.get(
  `/templates/v2/${code}`,
  {
    cancelToken,
    params,
  },
);

export const getTemplateDetailShareService = ({ code, ...params }, cancelToken) => api.get(
  `/shares/templates/${code}`,
  {
    cancelToken,
    ...params,
  },
);
